import ProjectExpertPodsModule from './project-expert-pods.module'

export default ProjectExpertPodsModule
